import type {
  CandidateJobApi,
  CandidateStatusApi,
} from '@/modules/candidates/types';

export const candidateFullName = (candidateJob: CandidateJobApi) =>
  `${candidateJob.candidate.firstName} ${candidateJob.candidate.lastName}`.trim();

/**
 * Title and company of the open work experience, else the latest one; without
 * any, the headline stands in for the title.
 */
export const candidateCurrentRole = (
  candidateJob: CandidateJobApi,
): { title?: string; company?: string } => {
  const experiences = candidateJob.candidate.workExperiences ?? [];
  const latest =
    experiences.find((experience) => !experience.endDate) ?? experiences[0];
  if (latest) return { title: latest.jobTitle, company: latest.companyName };
  return { title: candidateJob.candidate.headline ?? undefined };
};

/** "Senior Designer at Acme" from the open work experience, else the headline. */
export const candidateCurrentWork = (
  candidateJob: CandidateJobApi,
): string | undefined => {
  const { title, company } = candidateCurrentRole(candidateJob);
  return company ? `${title} at ${company}` : title;
};

/** Customer-facing label for the exact pipeline status. */
export const candidateStatusLabels: Partial<
  Record<CandidateStatusApi, string>
> = {
  New: 'Sourced',
  Shortlisted: 'Shortlisted',
  ContactStarted: 'Contact started',
  Contacted: 'Contacted',
  PrescreeningScheduled: 'Pre-screen scheduled',
  Prescreened: 'Pre-screened',
  AiPrescreened: 'AI pre-screened',
  AssessmentCompleted: 'Assessment completed',
  ReadyForSubmission: 'Ready to introduce',
};
